import React, { useState } from 'react';
import OfferAddon from '../../models/OfferAddon';
import MultiSelectField from '../../components/form/MultiSelectField';

const FormPartialNew = (props) => {
  const { offerAddon, setOfferAddon } = props;
  const [filtersModel, setFiltersModel] = useState({});
  const [resetOffers, setResetOffers] = useState([]);
  let offerAddonObj = new OfferAddon(offerAddon);
  const [discountConfiguration, setDiscountConfiguration] = useState('discount_amount');

  const validateValue = (field) => {
    offerAddonObj.validate(field);
  }

  const changeValue = (field, value) => {
    offerAddonObj[field] = value;
    validateValue(field);
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const onAddonSelect = (selectedList, selectedItem) => {
    offerAddonObj.addon_id = selectedItem.id ;
    validateValue('addon_id');
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const onAddonRemove = (selectedList, removedOption) => {
    offerAddonObj.addon_id = "";
    validateValue('addon_id');
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const onBranchSelect = (selectedList, selectedItem) => {
    offerAddonObj.circle_id = selectedItem.id;
    validateValue('circle_id');
    setResetOffers(false);
    offerAddonObj.offer_ids = [];
    setFiltersModel((prevState) => {
      return { ...prevState, branch_ids: [selectedItem.id], offer_ids: [] }
    })
    setOfferAddon(offerAddonObj.toStateJson());
  }

  // const onBranchRemove = (selectedList, removedOption) => {
  //   offerAddonObj.circle_id = "";
  //   validateValue('circle_id');
  //   offerAddonObj.offer_ids = [];
  //   setOfferAddon(offerAddonObj.toStateJson());
  //   setResetOffers(true);
  //   setFiltersModel((prevState) => {
  //     return { ...prevState, branch_ids: prevState.branch_ids.filter((id) => id !== removedOption.id) }
  //   })
  // }

  const onOfferSelect = (selectedList, selectedItem) => {
    offerAddonObj.offer_ids.push(selectedItem.id);
    validateValue('offer_ids');
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const onOfferRemove = (selectedList, removedOption) => {
    offerAddonObj.offer_ids = offerAddonObj.offer_ids.filter((item) => item !== removedOption.id);
    validateValue('offer_ids');
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const resetDicountConfiguration = (type) => {
    if (type === 'discount_amount') {
      offerAddonObj.discount_percentage = "";
      offerAddonObj.percentage_max_discount_amount = "";
    } else {
      offerAddonObj.discount_amount = "";
    }
    setOfferAddon(offerAddonObj.toStateJson());
  }

  const handleConfigurationType = (e) => {
    setDiscountConfiguration(e.target.value);
    resetDicountConfiguration(e.target.value);
  }

  return <>
    <div className="mb-2 mt-3 row">
    <div className="mb-3 col-md-6">
        <label htmlFor="name" className="form-label mb-1">Addon</label>
        <MultiSelectField
          id="addon_id"
          options={[]}
          fieldName="addon_id"
          stateModel={offerAddon}
          dynamicOptions={{
            dependsOnFields: [],
            apiName: "addons",
            dataAttr: "addons",
          }}
          singleSelect={true}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={(selectedList, selectedItem) => onAddonSelect(selectedList, selectedItem)}
          onRemove={(selectedList, removedItem) => onAddonRemove(selectedList, removedItem)}
        />
        <div id="addon_id_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.addon_id}
        </div>
      </div>
      <div className="mb-3 col-md-6">
        <label htmlFor="circle_id" className="form-label mb-1">Circle</label>
        <MultiSelectField
          id="circle_id"
          options={[]}
          fieldName="circle_id"
          stateModel={offerAddon}
          dynamicOptions={{
            dependsOnFields: [],
            apiName: "branches",
            dataAttr: "branches",
          }}
          singleSelect={true}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={(selectedList, selectedItem) => onBranchSelect(selectedList, selectedItem)}
          // onRemove={(selectedList, removedItem) => }
          showCheckbox={false}
          disable={offerAddonObj.addon_id === ""}
        />
        <div id="branch_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.circle_id}
        </div>
      </div>
      <div className="mb-3 col-md-6">
        <label htmlFor="name" className="form-label mb-1">Offers</label>
        <MultiSelectField
          id="offer_ids"
          options={[]}
          reset={resetOffers}
          fieldName="offer_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: ["branch_ids"],
            apiName: "offers",
            dataAttr: "offers",
          }}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={(selectedList, selectedItem) => onOfferSelect(selectedList, selectedItem)}
          onRemove={(selectedList, removedItem) => onOfferRemove(selectedList, removedItem)}
          disable={filtersModel.branch_ids === undefined || filtersModel.branch_ids.length <= 0}
        />
        <div id="offer_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.offer_ids}
        </div>
      </div>
      <div className="mb-3 col-md-12 d-flex btn-group">
        <div className="pt-2 me-1 ms-1">
          <input 
            className='btn-check'
            defaultChecked
            type="radio"
            id="type2"
            name="discount_type"
            value="discount_amount"
            onChange={handleConfigurationType}
          />
          <label className='btn btn-sm btn-outline-success' style={{ fontSize: '12px' }} htmlFor="type2">
            Configure By Discount Amount
          </label>
        </div>
        <div className="pt-2 me-1 ms-1">
          <input
            className='btn-check'
            type="radio"
            id="type1"
            name="discount_type"
            value="discount_percentage"
            onChange={handleConfigurationType}
          />
          <label className='btn btn-sm btn-outline-success' style={{ fontSize: '12px' }} htmlFor="type1">
            Configure By Discount Percentage
          </label>
        </div>
      </div>
      {
        discountConfiguration == 'discount_amount' && <div className="mb-3 col-md-6">
          <label htmlFor="discount_amount" className="form-label mb-1">Discount Amount</label>
          <input
            id="discount_amount"
            type="number"
            value={offerAddonObj.discount_amount}
            onChange={(e) => changeValue('discount_amount', e.target.value)}
            className="form-control form-control-sm font-size-12"
            aria-describedby="discountAmountHelp"
            placeholder='Enter Discount Amount'
          />
          <div id="schemeDescriptionHelp" className="form-text text-danger mt-0">
            {offerAddonObj.errors.discount_amount}
          </div>
        </div>
      }
      {discountConfiguration == 'discount_percentage' && <>
        <div className="mb-3 col-md-6">
          <label htmlFor="discount_percentage" className="form-label mb-1">Discount Percentage (%)</label>
          <input
            id="discount_percentage"
            type="number"
            value={offerAddonObj.discount_percentage}
            onChange={(e) => changeValue('discount_percentage', e.target.value)}
            className="form-control form-control-sm font-size-12"
            aria-describedby="discount_percentage_help"
            placeholder='Enter Discount Percentage'
            min="0"
            max="100"
          />
          <div id="discount_percentage_help" className="form-text text-danger mt-0">
            {offerAddonObj.errors.discount_percentage}
          </div>

        </div>
        <div className="mb-3 col-md-6">
          <label htmlFor="percentage_max_discount_amount" className="form-label mb-1">Max Discount Amount</label>
          <input
            id="percentage_max_discount_amount"
            type="number"
            min='1'
            max='100'
            value={offerAddonObj.percentage_max_discount_amount}
            onChange={(e) => changeValue('percentage_max_discount_amount', e.target.value)}
            className="form-control form-control-sm font-size-12"
            placeholder='Enter Max Discount'
          />
        </div>
      </>}
      <div className="mb-3 col-md-6">
        <label htmlFor="start_date" className="form-label mb-1">Start Date</label>
        <input 
          type="date"
          value={offerAddonObj.start_date}
          onChange={(e) => changeValue('start_date', e.target.value)}
          className="form-control form-control-sm font-size-12"
          id="start_date"
          aria-describedby="start_date_help"
        />
        <div id="start_date_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.start_date}
        </div>
      </div>
      <div className="mb-3 col-md-6">
        <label htmlFor="end_date" className="form-label mb-1">End Date</label>
        <input
          disabled={!offerAddonObj.start_date}
          type="date" value={offerAddonObj.end_date}
          onChange={(e) => changeValue('end_date', e.target.value)}
          className="form-control form-control-sm font-size-12"
          id="end_date"
          aria-describedby="end_date_help"
        />
        <div id="end_date_help" className="form-text text-danger mt-0">
          {offerAddonObj.errors.end_date}
        </div>
      </div>
    </div>
  </>
}

export default FormPartialNew;
